/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 后台-ugc-用户爆料
 */
"use strict";
angular
    .module("userBurstModule", ["revisedLineHeightModule"])
    .controller("userBurstCtrl", [
        "$scope",
        "$filter",
        "httpService",
        "$timeout",
        "$sce",
        "$q",
        "newPageScrollPic",
        function ($scope, $filter, httpService, $timeout, $sce, $q,newPageScrollPic) {
            initStatus();
            initData();
            /**
             * [initStatus description] 初始化参数
             */
            function initStatus() {
                $scope.status = {
                    inputData: "",
                    copyCurrPage: 1,
                };
                $scope.data = {
                    listData: [],
                    keywords: "", //检索的关键词
                };
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 20,
                    ITEMCOUNT: 0,
                };
            }

            function initData() {
                requestData();
            }

            $scope.requestData = function () {
                requestData();
            };
            /**
             * [requestData description] 初始化列表数据
             */
            function requestData() {
                var params = {
                    startTime: $scope.status.startDate,
                    endTime: $scope.status.endDate,
                    searchWord: $scope.data.keywords,
                    searchTime: "",
                    currPage: $scope.page.CURRPAGE,
                    pageSize: $scope.page.PAGESIZE,
                };
                $scope.loadingPromise = httpService
                    .http("/mcnadmin/admin/article/brokeList.do", params, "get")
                    .then(function (data) {
                        $scope.page = {
                            CURRPAGE: data.data.startPage,
                            PAGESIZE: data.data.pageSize,
                            ITEMCOUNT: data.data.totalResults,
                            PAGECOUNT: data.data.totalPages,
                        };
                        // for (var i in data.data.ldata) {
                        // data.data.ldata[i].imgurl = !!data.appendixMap[data.data.ldata[i].id] ? (function(array) {
                        //     var imgurl = [];
                        //     for (var j in array) {
                        //         if (array[j].filePath != null) {
                        //             imgurl.push(angular.globalConfig.pictureServer + array[j].filePath);
                        //         }
                        //         if (array[j].fileType == 101 || array[j].fileType == 201) {
                        //             downLoadVideo(array[j].fileName,array[j].fileType).then(function(data) {
                        //                 imgurl.push(data);
                        //             });
                        //         }
                        //     }
                        //     return imgurl;
                        // })(data.appendixMap[data.data.ldata[i].id]) : [];
                        for (var i in data.data.ldata) {
                            data.data.ldata[i].imgurl = !!data.appendixMap[
                                data.data.ldata[i].id
                            ]
                                ? (function (array) {
                                    var imgurl = [];
                                    for (var j in array) {
                                        if (array[j].filePath != null && array[j].fileType == 0) {
                                            imgurl.push(
                                                angular.globalConfig.pictureServer + array[j].filePath
                                            );
                                        }
                                        //   if (
                                        //       array[j].fileType == 101 ||
                                        //       array[j].fileType == 201
                                        //   ) {
                                        //       if (!isNaN(array[j].fileName)) {
                                        //           downLoadVideo(
                                        //               array[j].fileName,
                                        //               array[j].fileType
                                        //           ).then(function(data) {
                                        //               imgurl.push(data);
                                        //           });
                                        //       }
                                        //   }
                                    }
                                    return imgurl;
                                })(data.appendixMap[data.data.ldata[i].id])
                                : [];
                            data.data.ldata[i].videourl = !!data.appendixMap[
                                data.data.ldata[i].id
                            ]
                                ? (function (array) {
                                    var videourl = [];
                                    for (var j in array) {
                                        if (array[j].filePath != null && array[j].fileType == 3) {
                                            videourl.push(
                                                angular.globalConfig.pictureServer + array[j].filePath
                                            );
                                        }
                                    }
                                    return videourl;
                                })(data.appendixMap[data.data.ldata[i].id])
                                : [];
                            data.data.ldata[i].audiourl = !!data.appendixMap[
                                data.data.ldata[i].id
                            ]
                                ? (function (array) {
                                    var audiourl = [];
                                    for (var j in array) {
                                        if (array[j].filePath != null && array[j].fileType == 2) {
                                            audiourl.push(
                                                angular.globalConfig.pictureServer + array[j].filePath
                                            );
                                        }
                                    }
                                    return audiourl;
                                })(data.appendixMap[data.data.ldata[i].id])
                                : [];
                        }
                        /**
                         * [downLoadVideo description] 视屏展示
                         */
                        function downLoadVideo(id, libType) {
                            var deffer = $q.defer();
                            if (id == "undefined") return;
                            httpService
                                .http(
                                    "/mcnadmin/web/cloud/getVideoUrl.do",
                                    { id: id, libType: libType },
                                    "get"
                                )
                                .then(function (data) {
                                    if (data.data) {
                                        deffer.resolve(data.data.videoUrl);
                                    }
                                });
                            return deffer.promise;
                        }
                        $scope.data.listData = data.data.ldata;
                        //遍历爆料列表，添加一个istrue属性
                        for (var i = 0; i < $scope.data.listData.length; i++) {
                            $scope.data.listData[i].istrue = false;
                        }
                        //获取报料列表的类型
                        for (var i = 0; i < data.data.ldata.length; i++) {
                            if (
                                data.appendixMap[String($scope.data.listData[i].id)].length == 1
                            ) {
                                $scope.data.listData[i].filetype =
                                    data.appendixMap[
                                        String($scope.data.listData[i].id)
                                    ][0].fileType;
                            } else if (
                                data.appendixMap[String($scope.data.listData[i].id)].length > 1
                            ) {
                                $scope.data.listData[i].filetype =
                                    data.appendixMap[
                                        String($scope.data.listData[i].id)
                                    ][1].fileType;
                            }
                        }
                        findPicture($scope.data.listData, data.appendixMap);
                    });
            }
            /**
             * [handleArticleContent description] 处理爆料正文
             * @param {[object]} [item] [description] 爆料信息
             * @return {[null]} [description]
             */
            $scope.handleArticleContent = function (item) {
                var contentArray = item.articleContent.split(/\n/);
                for (var i in contentArray) {
                    contentArray[i] = contentArray[i].replace(/ /g, "&nbsp");
                    contentArray[i] = "<span>" + contentArray[i] + "</span>";
                }
                item.articleContent = contentArray.join("<br>");
                //item.articleContent = $sce.trustAsHtml(item.articleContent.replace(/\n/g, "<br>").replace(/ /g,"&nbsp;"));
            };
            /**
             * [findPicture description] 图片比对
             */
            function findPicture(item, appendixMap) {
                for (var i = 0; i < item.length; i++) {
                    var items = appendixMap[item[i].id];
                    if (items.length > 0) {
                        item[i].imgUrl = items;
                    }
                }
            }
            /**
             * [openpic description]打开一个图片
             *
             * @param   {[type]}  items  [items description]
             *
             * @return  {[type]}         [return description]
             */
            $scope.openpic = function (items) {
                newPageScrollPic.alertScrollPic(items);
            };
            /**
             * [fullTextSearch description;全文检索]
             * @param  {[type]} ev [description:按下回车也能提交]
             */
            $scope.fullTextSearch = function (ev) {
                if (
                    (angular.isDefined(ev) && ev.keyCode == 13) ||
                    angular.isUndefined(ev)
                ) {
                    requestData();
                }
            };
            /**
             * [isUnfold description] 爆料列表，文本展开收起函数
             * @return {Boolean} [description]
             */
            $scope.isUnfold = function (pre) {
                $scope.data.listData[pre].istrue = !$scope.data.listData[pre].istrue;
            };
        },
    ]);
